import React from 'react'
import PropTypes from 'prop-types'

import WithChrome from './WithChrome'
import WithoutChrome from './WithoutChrome'

const propTypes = {
	src: PropTypes.string.isRequired,
	alt: PropTypes.string,
	showChrome: PropTypes.bool,
}

const defaultProps = {
	showChrome: true,
	alt: '',
}

const MobileScreen = ({ src, alt, showChrome }) => {
	const Tag = showChrome ? WithChrome : WithoutChrome
	return <Tag src={src} alt={alt} />
}

MobileScreen.propTypes = propTypes
MobileScreen.defaultProps = defaultProps

export default MobileScreen
